












































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CodeShowcase from '@/components/flexOption/CodeShowcase.vue';

@Component({
  components: {
    CodeShowcase,
  },
})
export default class Visualizer extends Vue {
  @Prop({ type: String, default: 'Alignments' })
  private dropdownButtonTitle!: string;

  @Prop({ type: Boolean, default: false })
  private focusOneItem!: boolean;

  @Prop({ type: String, default: '' })
  private defaultFlexValue!: string;

  @Prop({ type: Boolean, default: false })
  private differentSize!: boolean;

  @Prop({ type: Boolean, default: false })
  private isFlexItem!: boolean;

  @Prop({ type: String, default: '' })
  private flexAttribute!: string;

  @Prop({ type: Array, default: [] })
  private flexOptions!: string[];

  @Prop({ type: String, default: '' })
  private styleForAlternateSquares!: string;

  private flexOption: string = this.defaultFlexValue;

  private containerWidth = 100;

  private changeFlexOption(option: string): void {
    this.flexOption = option;
  }

  private get darkMode(): boolean {
    return this.$store.state.darkMode;
  }

  private get applyStyles(): Object {
    return {
      [this.flexAttribute]: this.flexOption,
    };
  }
}
